export default __webpack_public_path__ + "static/media/480_business08-jp-mobile.b3f5bdf9.png";